import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Third party
import { NgSelectModule } from '@ng-select/ng-select';
import { PrettyJsonModule } from 'angular2-prettyjson';

// Local
import { ProcessAutomationComponent } from './process-automation.component';
import { BtnTriggerComponent } from './btn-trigger/btn-trigger.component';
import { ManageConditionsComponent } from './manage-conditions/manage-conditions.component';
import { ManageCompletionComponent } from './manage-completion/manage-completion.component';
import { ManageFormComponent } from './manage-form/manage-form.component';
import { ManageDocumentComponent } from './manage-document/manage-document.component';
import { ManageFunctionComponent } from './manage-function/manage-function.component';
import { ManageAssociationComponent } from './manage-association/manage-association.component';
import { DuplicateProcessComponent } from './duplicate-process/duplicate-process.component';
import { RefactoringCompletionsComponent } from './refactoring-completions/refactoring-completions.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {
  ManageSecondaryCompletionsComponent
} from './manage-secondary-completions/manage-secondary-completions.component';
import {
  ManageSecondaryDetailComponent
} from './manage-secondary-detail/manage-secondary-detail.component';
import { FlowNavigatorComponent } from './flow-navigator/flow-navigator.component';
import { ManagementCheckListFormComponent } from './management-check-list-form/management-check-list-form.component';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { NotifierService } from '@app/shared/services/notifier.service';
import { ManageRestrictionDocumentComponent } from './manage-restriction-document/manage-restriction-document.component';
import { SelectTramiteDuplicateComponent } from '@app/shared/select-tramite-duplicate/select-tramite-duplicate.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    PrettyJsonModule,
    ScrollToModule,
    CollapseModule,
    SharedAdministrationModule
  ],
  declarations: [
    ProcessAutomationComponent,
    BtnTriggerComponent,
    ManageConditionsComponent,
    ManageCompletionComponent,
    ManageFormComponent,
    ManageDocumentComponent,
    ManageFunctionComponent,
    ManageRestrictionDocumentComponent,
    ManageAssociationComponent,
    DuplicateProcessComponent,
    RefactoringCompletionsComponent,
    ManageSecondaryCompletionsComponent,
    ManageSecondaryDetailComponent,
    FlowNavigatorComponent,
    ManagementCheckListFormComponent,
  ],
  exports: [
    ProcessAutomationComponent,
    BtnTriggerComponent,
    DuplicateProcessComponent
  ],
  providers: [NotifierService],
  entryComponents: [SelectTramiteComponent, SelectTramiteDuplicateComponent]
})
export class ProcessAutomationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/process-automation.module.ts